import { getTransactionStats } from "@/services/transactions.service";
import { useQuery } from "@tanstack/react-query";

export const useTransactionStats = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["transactionStats"],
    queryFn: getTransactionStats,
    select: (res) => res?.data,
  });

  return {
    stats: {
      totalTransaction: data?.totalTransaction ?? 0,
      totalSuccess: data?.totalSuccess ?? 0,
      totalFailed: data?.totalFailed ?? 0,
      totalAbandoned: data?.totalAbandoned ?? 0,
      totalPending: data?.totalPending ?? 0,
      totalSettled: data?.totalSettled ?? 0,
      totalRefunded: data?.totalRefunded ?? 0,
      totalDeclined: data?.totalDeclined ?? 0,
    },
    isLoading,
    isError,
  };
};
